import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {inject} from 'mobx-react';

import {containers as BaseContainers} from '../modules/core';
import {containers as ProfileContainer} from '../modules/profile';
import {containers as DashboardContainers} from '../modules/dashboard';
import {containers as Tracker} from '../modules/personaTrecker';
import {containers as CategoriesContainer} from '../modules/categories';
import {containers as TutorialContainer} from '../modules/tutorial';
import {containers as TopicContainer} from '../modules/topic';
import {containers as ReimbursedContainer} from '../modules/reimbursed';
import NotFound from 'modules/blocks/404';
import EmptyTracker from 'modules/blocks/EmpryTracker'
import SearchComponent from 'modules/search/SearchComponent';
import AboutUs from 'modules/informations/AboutUs';
import ContactUs from 'modules/informations/ContactUs';
import TermsOfService from 'modules/informations/TermsOfService';
import PrivacyPolicy from 'modules/informations/PrivacyPolicy';
import CookiesPolicy from 'modules/informations/CookiesPolicy';
import Breadcrumbs from 'modules/core/components/Breadcrumbs';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import customBaseTheme from 'modules/theme/customBaseTheme';
import LiveEvents from 'modules/informations/LiveEvents';
import {containers as ExamPrepDashboardContainer} from 'modules/examPrepDashboard';
import {containers as ResourcesContainer} from '../modules/resources';

const {
  Header,
  ExamPrepHeader,
  Sidebar,
  Footer
} = BaseContainers;

const {
  Base
} = DashboardContainers;

const {
  PersonalTracker
} = Tracker;

const {
  Profile,
  Logout
} = ProfileContainer;

const {
    Categories
} = CategoriesContainer;

const {
    Tutorial
} = TutorialContainer;
const {
  Topic,
  TopicOnlyQuiz,
  TopicsList
} = TopicContainer;

const {Reimbursed} = ReimbursedContainer;

const {ExamPrepDashboard} = ExamPrepDashboardContainer;

const {
  AddResource,
  Resources,
  EditResource,
} = ResourcesContainer;

@inject('userStore')
export default class extends Component {
  render() {
    const {isExamPrepUser, user} = this.props.userStore;
    const showExamPrep = isExamPrepUser() && user.role !== 'admin';

    return (
      <MuiThemeProvider muiTheme={getMuiTheme(customBaseTheme)} key={3}>
        <div className="public-wrap">
          {showExamPrep ? (
            <ExamPrepHeader />
          ) : (
            <Header />
          )}
          {!showExamPrep && (
            <Breadcrumbs/>
          )}
          <Switch>
            <Route path="/settings" component={Profile}/>
            <Route path="/dashboard" component={TopicsList}/>
            <Route path="/micgp-exam-prep" component={PersonalTracker}/>
            <Route path="/reimbursed" component={Reimbursed}/>
            <Route path="/categories" component={Categories}/>
            <Route path="/logout" component={Logout}/>
            <Route path="/notfound" component={NotFound}/>
            <Route path="/emptytracker" component={EmptyTracker}/>

            <Route path="/aboutus" component={AboutUs}/>
            <Route path="/contactUs" component={ContactUs}/>
            <Route path="/terms-of-service" component={TermsOfService}/>
            <Route path="/privacy-policy" component={PrivacyPolicy}/>
            <Route path="/cookies-policy" component={CookiesPolicy}/>

            <Route path="/tutorial/:slug" component={Tutorial}/>
            <Route path="/search/:title?" component={SearchComponent}/>
            <Route path="/live-events" component={LiveEvents} exact/>

            <Route path="/" exact component={showExamPrep ? ExamPrepDashboard : TopicsList}/>

            <Route path="/topics" component={TopicsList} exact/>
            <Route path="/topic" component={Topic} exact/>
            <Route path="/topic/:id" component={Topic} />

            <Route path="/exam-prep/:id/reimbursed" component={Reimbursed}/>
            <Route path="/exam-prep/:id/topics" component={TopicsList}/>
            <Route path="/exam-prep/topic" component={Topic} exact/>
            <Route path="/exam-prep/topic/:id" component={Topic} />
            <Route path="/quiz/:id" component={TopicOnlyQuiz} />

            {user.role === 'admin' && (
              <Route path="/practice-cases/add" component={AddResource} exact />
            )}
            {user.role === 'admin' && (
              <Route path="/practice-cases" component={Resources} exact />
            )}
            {user.role === 'admin' && (
              <Route path="/practice-cases/:id/edit" component={EditResource} />
            )}
            <Route path="/exam-prep/:id/practice-cases" component={Resources} exact />

            <Redirect to="/notfound"/>
          </Switch>
          <Sidebar/>
          <Footer/>
        </div>
      </MuiThemeProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/private.js